<template>
  <button class="next" @click="$emit('click')" :disabled="isDisabled">
    <slot name="icon-prev">
      <svg class="prev" width="16" height="14" viewbox="0 0 16 14">
        <use xlink:href="#arrow-long"></use>
      </svg>
    </slot>
    <span class="label"><slot></slot></span>
    <slot name="icon-next">
      <svg class="next" width="16" height="14" viewbox="0 0 16 14">
        <use xlink:href="#arrow-long"></use>
      </svg>
    </slot>
  </button>
</template>

<script>
export default {
  props: {
    isDisabled: {
      type: Boolean,
      value: false,
    },
  },
}
</script>

<style lang="scss" scoped>
button {
  @include button;
}

.sticky_button {
  position: sticky;
  top: 8px;
  left: 100%;
  margin: 0;
}
</style>
